module.exports = __webpack_public_path__ + "img/ic_reembolso.412c9191.svg";